import { ColorOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CMS_COMPONENT_LISTING_CONFIG } from '../../../component/listing/cms-component-listing.config';
import { NCmsBlogComponentListing } from './cms-blog-component-listing.interface';

export const CMS_BLOG_COMPONENT_LISTING_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsBlogComponentListing.ID,
    name: 'Blog Listing',
    fields: [
        {
            key: 'heading',
            type: NICmsContentField.EFieldType.text,
            title: 'Heading',
            default: 'The Oliver Bonas Blog'
        },
        <NICmsContentField.IChoiceField>{
            key: 'text_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text Style',
            options: TextStyleOptions,
            default: 'h2'
        },
        <NICmsContentField.IChoiceField>{
            key: 'color',
            type: NICmsContentField.EFieldType.choice,
            colorPreview: true,
            title: 'Text Color',
            options: ColorOptions,
            default: ''
        },
        ...CMS_COMPONENT_LISTING_CONFIG.fields
    ]
};
